<router-outlet></router-outlet>
<div id="toast-container" class="fixed top-4 end-4 z-50 w-64"></div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type="ball-spin-clockwise" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
